import { Grid } from '@material-ui/core'
import { useState } from 'react'
import { Button, useNotify, useTranslate } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'

export const CreateSubButton = ({
  setOpenResolutionId,
  setIsChanged,
  setOpen,
  ...props
}) => {
  const [disabled_btn, setDisabledBtn] = useState(false)
  const { record } = props
  const classes = useStyles()
  const translate = useTranslate()
  const notify = useNotify()
  if (record.parent_id !== null) return null

  const create = async () => {
    const payload = { ...record, createopensub: true }
    setDisabledBtn(true)
    const result = await Api.resolutions.update(record.id, payload)
    const { data } = result
    if (result.status === 200) {
      setDisabledBtn(false)
      setOpen(false)
      setOpenResolutionId(data.id)
      setIsChanged((prev) => {
        let newVal = new Date().getTime()
        return newVal
      })
    } else {
      notify(`${data.message}`)
      setDisabledBtn(false)
    }
    setDisabledBtn(false)
  }

  return (
    <Grid item xs={12}>
      <Button
        disabled={disabled_btn}
        className={classes.actionButton}
        variant="contained"
        size="normal"
        color="secondary"
        label={translate('hs.ags.create_subresolution')}
        onClick={create}
      />
    </Grid>
  )
}
export default CreateSubButton
